import type {User} from "../../mixins/UserMixin";
import {useStorage} from "./useStorage";

export const useSessionStorage = (user?: User) => useStorage(sessionStorage, user);